import type { IconData } from '@stacksjs/iconify-core'

export const menu: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M80 96h352v32H80zm0 144h352v32H80zm0 144h352v32H80z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default menu
